export default {"src":"/_next/static/media/icon_close_modal.8c2bc528.svg","height":51,"width":52,"blurWidth":0,"blurHeight":0};